export default {
    audit: {
        list: '/basic/audit/list' // 用户列表查询
    },
    health: {
        list: '/basic/appHealth/list', // 健康列表列表
        history: '/basic/appHealth/history/' // 健康历史列表
    },
    cluster: {
        list: '/basic/cluster/listAllService'
    }
};
